import { PUBLIC_SECTION_SURFACES } from './publicSectionSurfaces';
import { PublicSectionWaveBottom } from './PublicSectionWave';

/** Tarification : transition vers Vacations / fond page. */
export function PublicTarifsWaveBottom() {
  return <PublicSectionWaveBottom fill={PUBLIC_SECTION_SURFACES.afterTarifs} />;
}
